import { defineMessages } from "react-intl"

export default defineMessages({
  faqTitle: {
    id: "app.components.Faq.faqTitle"
  },
  searchBarDescription: {
    id: "app.components.Faq.searchBarDescription"
  },
  closeAll: {
    id: "app.components.Faq.closeAll"
  },
  section1Title: {
    id: "app.components.Faq.section1Title"
  },
  section1Q1: {
    id: "app.components.Faq.section1Q1"
  },
  section1Q2: {
    id: "app.components.Faq.section1Q2"
  },
  section1Q3: {
    id: "app.components.Faq.section1Q3"
  },
  section1Q4: {
    id: "app.components.Faq.section1Q4"
  },
  section1Q5: {
    id: "app.components.Faq.section1Q5"
  },
  section1Q6: {
    id: "app.components.Faq.section1Q6"
  },
  section1Q7: {
    id: "app.components.Faq.section1Q7"
  },
  section1Q8: {
    id: "app.components.Faq.section1Q8"
  },
  section1A1: {
    id: "app.components.Faq.section1A1"
  },
  section1A2: {
    id: "app.components.Faq.section1A2"
  },
  section1A3: {
    id: "app.components.Faq.section1A3"
  },
  section1A4: {
    id: "app.components.Faq.section1A4"
  },
  section1A5: {
    id: "app.components.Faq.section1A5"
  },
  section1A6: {
    id: "app.components.Faq.section1A6"
  },
  section1A7: {
    id: "app.components.Faq.section1A7"
  },
  section1A8: {
    id: "app.components.Faq.section1A8"
  },
  section2Title: {
    id: "app.components.Faq.section2Title"
  },
  section2Q1: {
    id: "app.components.Faq.section2Q1"
  },
  section2A1: {
    id: "app.components.Faq.section2A1"
  },
  section2Q2: {
    id: "app.components.Faq.section2Q2"
  },
  section2A2: {
    id: "app.components.Faq.section2A2"
  },
  section3Title: {
    id: "app.components.Faq.section3Title"
  },
  section3Q1: {
    id: "app.components.Faq.section3Q1"
  },
  section3Q2: {
    id: "app.components.Faq.section3Q2"
  },
  section3Q3: {
    id: "app.components.Faq.section3Q3"
  },
  section3Q4: {
    id: "app.components.Faq.section3Q4"
  },
  section3A1: {
    id: "app.components.Faq.section3A1"
  },
  section3A2: {
    id: "app.components.Faq.section3A2"
  },
  section3A3: {
    id: "app.components.Faq.section3A3"
  },
  section3A4: {
    id: "app.components.Faq.section3A4"
  },
  section4Title: {
    id: "app.components.Faq.section4Title"
  },
  section4Q1: {
    id: "app.components.Faq.section4Q1"
  },
  section4Q2: {
    id: "app.components.Faq.section4Q2"
  },
  section4Q3: {
    id: "app.components.Faq.section4Q3"
  },
  section4Q4: {
    id: "app.components.Faq.section4Q4"
  },
  section4Q5: {
    id: "app.components.Faq.section4Q5"
  },
  section4Q6: {
    id: "app.components.Faq.section4Q6"
  },
  section4A1: {
    id: "app.components.Faq.section4A1"
  },
  section4A2: {
    id: "app.components.Faq.section4A2"
  },
  section4A3: {
    id: "app.components.Faq.section4A3"
  },
  section4A4: {
    id: "app.components.Faq.section4A4"
  },
  section4A5: {
    id: "app.components.Faq.section4A5"
  },
  section4A6: {
    id: "app.components.Faq.section4A6"
  },
  section5Title: {
    id: "app.components.Faq.section5Title"
  },
})
